module.exports = __webpack_public_path__ + "img/chop-logo.ac500c1f.png";